import { FeedItem } from '@knocklabs/client';

import { NotificationTarget } from 'core/constants';

import { NotificationType } from 'utils/api/modules/user/user.types';
import Logger from 'utils/logger';

import { TARGET_TO_CATEGORY } from 'containers/KnockNotifications/constants';

interface KnockNotificationData {
  target?: string;
  instance_uuid?: string;
  instance_name?: string;
  instance_subject?: string;
  notification_url?: string;
}

export function knockItemToNotification(item: FeedItem): NotificationType {
  const data = (item.data ?? {}) as KnockNotificationData;
  const target = (data.target ?? '') as NotificationTarget;
  if (!(target in TARGET_TO_CATEGORY)) {
    Logger.warn(`Knock notification target "${target}" has no category mapping; item will be dropped from inbox`);
  }
  return {
    uuid: item.id,
    target,
    instance: {
      uuid: data.instance_uuid ?? '',
      name: data.instance_name ?? '',
      subject: data.instance_subject,
    },
    notificationUrl: data.notification_url,
    creator: {
      uuid: item.actors?.[0]?.id ?? '',
      name: (item.actors?.[0] as { name?: string })?.name ?? '',
    },
    created: item.inserted_at,
    dismissed: item.read_at !== null,
    activity: item.id,
  };
}
